import { Injectable } from '@angular/core';
import { ItemPivotModel } from '../items/item-pivot.model';
import { ApiRequestService } from './api-request.service';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../models/api-response.model';
import { PrequalificationModel } from '../models/prequalification.model';
import { HazardModel } from '../models/hazard.model';
import {UserModel} from "../models/user.model";
import { AppService } from '../app.service';

@Injectable({
  providedIn: 'root'
})
export class NoauthService {
  private readonly resourceUrl = 'v1/noauth';

  constructor(
    private api: ApiRequestService,
    public app: AppService
  ) {}

  private createFile(file: File, hash: string, item_pivot_id?: number) {
    const form = new FormData();
    form.append('file', file, file.name);
    if ( item_pivot_id ) {
      form.append('item_pivot_id', item_pivot_id.toString());
    }
    return this.api
      .makeRequestObservable('post', this.resourceUrl + `/files/${hash}`, form)
      .toPromise();
  }

  public async createFiles(files: FileList, hash: string, item_pivot_id?: number) {
    if (!files || !files.length) { return []; }
    const requests = [];
    for(let i = 0; i < files.length; i++) {
      requests.push(this.createFile(files[i], hash, item_pivot_id));
    }
    const responses = await Promise.all(requests);
    const createdFiles = responses.map(response => response.data);
    return createdFiles;
  }

  public updateItemPivot(
    id: number,
    hash: string,
    pivot: ItemPivotModel
  ): Promise<ApiResponseModel<void>> {
    const payload = this.attachUser({ ...pivot });
    return this.api
      .makeRequestObservable(
        'put',
        this.resourceUrl + `/pivot/${id}/${hash}`,
        payload
      )
      .toPromise();
  }

  public findPrequal(
    hash: string
  ): Observable<ApiResponseModel<PrequalificationModel>> {
    return this.api.makeRequestObservable(
      'get',
      this.resourceUrl + `/prequalifications/${hash}`
    );
  }

  public completePrequal(hash: string): Observable<ApiResponseModel<void>> {
    return this.api.makeRequestObservable(
      'post',
      this.resourceUrl + `/prequalifications/${hash}`
    );
  }

  public findHazard(hash: string): Observable<ApiResponseModel<HazardModel>> {
    return this.api.makeRequestObservable(
      'get',
      this.resourceUrl + `/hazards/${hash}`
    );
  }

  public verifyHazard(hash: string): Observable<{}> {
    return this.api.makeRequestObservable(
      'put',
      this.resourceUrl + `/hazards/${hash}/verify`
    );
  }

  public unVerifyHazard(hash: string): Observable<{}> {
    return this.api.makeRequestObservable(
      'put',
      this.resourceUrl + `/hazards/${hash}/un-verify`
    );
  }

  public notifyHazard(hash: string): Observable<{}> {
    return this.api.makeRequestObservable(
      'post',
      this.resourceUrl + `/hazards/${hash}/notify`
    );
  }

  public findUser(
    hash: string,
    eager_load: boolean
  ): Observable<ApiResponseModel<UserModel>> {
    return this.api.makeRequestObservable(
      'get',
      this.resourceUrl + `/users/${hash}`,
      null,
      {eager_load: eager_load}
    );
  }

  private attachUser(payload: any) {
    if (this.app?.user?.id) {
      payload.user_id = this.app.user.id;
    }
    return payload;
  }
}
